module.exports = "/_next/static/resources/life2-5d985ea53da8790cf86190b12a2f0311.webp";